
import { createSelector } from '@reduxjs/toolkit';


export const selectLatestTicks = createSelector(
    (state) => state.marketData.tokenData,
    (tokenData) => {
      const latestTicks = {};
      if (!tokenData) return latestTicks;
  
      for (const token in tokenData) {
        const priceArr = tokenData[token]?.priceData;
        if (priceArr && priceArr.length > 0) {
          latestTicks[token] = priceArr[priceArr.length - 1];
        }
      }
      console.log("latestTicks",[latestTicks])
      return [latestTicks];
    }
  );


  export const makeSelectLatestTickByToken = (token) => createSelector(
    (state) => state.marketData.tokenData[token]?.priceData,
    (priceData) => priceData?.[priceData.length - 1] ?? null
  );


  export const makeSelectLatestTicksByTokens = (tokens = []) =>
    createSelector(
      (state) => state.marketData.tokenData,
      (tokenData) => {
        const latestPrices = {};
  
        if (!Array.isArray(tokens) || tokens.length === 0 || !tokenData) {
          return latestPrices;
        }
  
        for (const token of tokens) {
          const data = tokenData[token]?.priceData;
          if (data && data.length > 0) {
            latestPrices[token] = data[data.length - 1];
          }
        }
  
        return latestPrices;
      }
    );
